import { IUser } from "authentication/domain/IUser";
import { authServices } from "authentication/services/auth.service";
import Modal from "components/Modal/Modal";
import { toast } from "react-toastify";

interface IProps {
  setClickOutsideActive: Function;
  isOpen: boolean;
  setIsOpen: Function;
  selectedUser: IUser | null;
  refresh: Function;
}

const DeleteUserModal = ({
  setClickOutsideActive,
  isOpen,
  setIsOpen,
  selectedUser,
  refresh,
}: IProps) => {
  const close = () => {
    setIsOpen(false);
    setClickOutsideActive(true);
  };

  const deleteUser = async () => {
    try {
      if (selectedUser) {
        await authServices.deleteUser(selectedUser.username);
        close();
        toast.success("Korisnik je uspešno obrisan.");
        refresh();
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClick={deleteUser}
      onClose={close}
      title="Brisanje postojećeg korisnika"
    >
      <p className="info-msg">
        Da li ste sigurni da želite da obrišete korisnika
        <br />
        <br />
        <b>{selectedUser?.username} ?</b>
      </p>
    </Modal>
  );
};

export default DeleteUserModal;
